import { ClassesBuilder } from '@utilities';

const classesConfig = {
  imageContainer: 'max-h-full',
  image: 'w-full h-auto',
};

export default new ClassesBuilder(classesConfig);
